interface StatusBadgeProps {
  status: 'ok' | 'warning' | 'error' | 'info' | 'unknown';
  label: string;
  size?: 'sm' | 'md';
}

const statusColors = {
  ok: { dot: 'bg-[var(--color-success)]', bg: 'bg-[var(--color-success-light)]', text: 'text-[var(--color-success)]' },
  warning: { dot: 'bg-[var(--color-warning)]', bg: 'bg-[var(--color-warning-light)]', text: 'text-[var(--color-warning)]' },
  error: { dot: 'bg-[var(--color-error)]', bg: 'bg-[var(--color-error-light)]', text: 'text-[var(--color-error)]' },
  info: { dot: 'bg-[var(--color-primary)]', bg: 'bg-[var(--color-primary-light)]', text: 'text-[var(--color-primary)]' },
  unknown: { dot: 'bg-[var(--color-text-muted)]', bg: 'bg-[var(--color-border-light)]', text: 'text-[var(--color-text-muted)]' },
};

export function StatusBadge({ status, label, size = 'md' }: StatusBadgeProps) {
  const colors = statusColors[status] || statusColors.unknown;
  const sizeClasses = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${colors.bg} ${colors.text} ${sizeClasses}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${colors.dot}`} />
      {label}
    </span>
  );
}
